import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { Container, CanvasBox, SubmenuItem } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Divider, Typography } from '@mui/material';
import { copyElement, elementChanged, elementUpdated, handleRedo, handleRemoveElement, handleUndo, pasteElement } from 'redux-layout/actions';
import CanvasElements from './CanvasElement';
import { Item, Menu as LolMenu, Submenu } from 'react-contexify';
import { COMPLEX_TEXT, IMG, MENU_ID, TEXT } from './config';
import ContextItem from '../Components/ContextifyItem';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { AlignBottom, AlignHorizontal, AlignIconRight, AlignLeft, AlignRight, AlignTop, AlignVertical, CopyIconRight, DeleteIconRight, LayerIconRight, PasteIconRight, ReplaceImageIcon } from 'config/svgs';
import { setHeightWidth } from 'redux-layout/studio/actions';
import { PHOTOS } from '../LeftAddElements/config';
import { StudioContext } from '..';

const CanvasFrame = ({ style, setStyle }) => {
    const dispatch = useDispatch();
    const lcanvasRef = useRef(null);
    const canvasFrameRef = useRef(null);
    const { project, selectedSlide, selectedElement } = useSelector((state) => state.Canvas.present);
    const pastArray = useSelector((state) => state.Canvas.past);
    const futureArray = useSelector((state) => state.Canvas.future);
    const { setElementType, setImageType } = useContext(StudioContext);

    useEffect(() => {
        let el = $('#canvasFrame');
        let hight = project.meta.size.height || '500';
        let width = project.meta.size.width || '1000';
        let top = (el.height() - (el.width() * 9) / 16) / 2;
        let left = (el.width() - (el.height() * 16) / 9) / 2;
        let elh = el.height();
        let elw = el.width();

        if (width > el.width()) {
            hight = (el.width() * 9) / 16;
            setStyle({
                height: hight + 'px',
                width: elw + 'px',
                top: top + 'px',
                left: '0px',
            });
            dispatch(setHeightWidth(hight + 'px', elw + 'px'));
        } else if (hight > el.height()) {
            width = (el.height() * 16) / 9;
            setStyle({
                height: elh + 'px',
                width: width + 'px',
                top: '0px',
                left: left,
            });
            dispatch(setHeightWidth(elh + 'px', width + 'px'));
        } else {
            width = (el.height() * 16) / 9;
            setStyle({
                height: elh + 'px',
                width: width + 'px',
                top: '0px',
                left: left,
            });
            dispatch(setHeightWidth(elh + 'px', width + 'px'));
        }
    }, [project]);


    const handleContext = ({ id, event, props }) => {
        let { element } = props;
        element = _.cloneDeep(element);
        let canvasRef = canvasFrameRef.current;
        let el = canvasRef.getBoundingClientRect();
        let elWidth = 0;
        if (typeof element.position.width === 'string') {
            if (element.position.width.includes('%')) {
                elWidth =
                    (parseFloat(element.position.width.replace('%', '')) * el.width) /
                    100;
            } else if (element.position.width.includes('px')) {
                elWidth = parseFloat(element.position.width.replace('px', ''));
            } else {
                elWidth = (parseFloat(element.position.width) * el.width) / 100;
            }
        } else {
            elWidth = (element.position.width * el.width) / 100;
        }
        let elHeight = 0;
        if (typeof element.position.height === 'string') {
            if (element.position.height.includes('%')) {
                elHeight =
                    (parseFloat(element.position.height.replace('%', '')) * el.height) /
                    100;
            } else if (element.position.height.includes('px')) {
                elHeight = parseFloat(element.position.height.replace('px', ''));
            } else {
                elHeight = (parseFloat(element.position.height) * el.height) / 100;
            }
        } else {
            elHeight = (element.position.height * el.height) / 100;
        }
        switch (id) {
            case 'copy':
                dispatch(copyElement(element));
                break;
            case 'paste':
                dispatch(pasteElement());
                break;
            case 'delete':
                dispatch(handleRemoveElement(props.element));
                break;
            case 'replace':
                setElementType(PHOTOS);
                setImageType('replace_image');
                break;
            case 'left':
                dispatch(elementUpdated(element, 0, 'left'));
                break;
            case 'center':
                let percentageWidth = ((el.width / 2 - elWidth / 2) * 100) / el.width;
                let percentageheight = ((el.height / 2 - elHeight / 2) * 100) / el.height;
                console.log('elementPosition', element?.position, element.position.left);
                element.position.left = percentageWidth;
                element.position.top = percentageheight;
                dispatch(elementChanged(element));
                break;
            case 'right':
                let percentageRightWidth = ((el.width - elWidth) * 100) / el.width;
                dispatch(elementUpdated(element, percentageRightWidth, 'left'));
                break;
            case 'top':
                dispatch(elementUpdated(element, 0, 'top'));
                break;
            case 'middle':
                let percentageMiddleWidth = ((el.width / 2 - elWidth / 2) * 100) / el.width;
                dispatch(elementUpdated(element, percentageMiddleWidth, 'left'));
                break;
            case 'bottom':
                let percentageBottomHeight = ((el.height - elHeight) * 100) / el.height;
                dispatch(elementUpdated(element, percentageBottomHeight, 'top'));
                break;
            case 'bring_front':
            case 'bring_forward':
            case 'send_backward':
            case 'send_back':
                dispatch(elementUpdated(element, id, 'z-index'));
                break;
            case 'developer':
                setElementType('DEVELOPER_BOX');
                break;
            default:
                break;
        }
    };

    const handleKeyPress = useCallback((event, props) => {
        const isMac = navigator.platform.toUpperCase().includes('MAC');
        const deleteKey = isMac ? 'Backspace' : 'Delete';

        let carretPosition = window.getSelection().rangeCount;
        const activeElement = document.activeElement;
        if (activeElement && (activeElement.className?.includes('rsw-ce') || activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
            return;
        }

        if (['Backspace', 'Delete'].includes(event.key)) {
            if (event.key === deleteKey && selectedElement.id) {
                dispatch(handleRemoveElement(selectedElement));
            }
            return;
        }

        if (event.ctrlKey || event.metaKey) {
            switch (event.key) {
                case 'c':
                    dispatch(copyElement(selectedElement));
                    break;
                case 'v':
                    dispatch(pasteElement());
                    break;
                case 'x':
                    if (selectedElement?.id) {
                        dispatch(copyElement(selectedElement));
                        dispatch(handleRemoveElement(selectedElement));
                    }
                    break;
                case 'z':
                    if (pastArray.length > 1) {
                        dispatch(handleUndo());
                    }
                    break;
                case 'y':
                    if (futureArray.length > 0) {
                        dispatch(handleRedo());
                    }
                    break;
                default:
                    break;
            }
        }
    }, [selectedElement]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);


    return (
        <Container>
            <CanvasBox
                id="canvasFrame"
                ref={canvasFrameRef}
                onDoubleClick={(e) => {
                    let id = e.target.id;
                    if (id === 'lcanvas' || id === 'canvasFrame') {
                        dispatch(elementChanged({}));
                    }
                }}
                onClick={(e) => {
                    // if (e.target.offsetParent?.className === 'rsw-ce' || e.target.className.includes('resizer') || e.target.className.includes('resizable-draggable') || e.target.className.includes('rsw-editor')) {
                    //     return;
                    // }
                    // if (!(e?.target?.className === 'edit-textarea') && !(e?.target?.className === 'iframe-wrapper') && !(e?.target?.className === 'rsw-ce') && !(e?.target?.className === 'rsw-toolbar')) {
                    //     if (typeof e?.target?.className === 'string') {
                    //         if (!e?.target?.className?.includes('parent-marker') && !e?.target?.className?.includes('resize-handle')) {
                    //             dispatch(elementChanged({}));
                    //         }
                    //     }
                    // }
                }}>
                <Box
                    id="lcanvas"
                    className="lcanvas"
                    ref={lcanvasRef}
                    style={{
                        width: style.width,
                        height: style.height,
                        borderRadius: '10px',
                        position: 'absolute',
                        // maxWidth: 'calc(100vw - 110px)',
                        // maxHeight: 'calc(100vh)',
                        backgroundImage: selectedSlide.style ? selectedSlide.style['background-image'] : '',
                        backgroundColor: selectedSlide.style ? selectedSlide.style['background-color'] : '',
                        objectFit: 'cover',
                        backgroundSize: 'cover',
                    }}>
                    <LolMenu id={MENU_ID} className="custom-lolmenu" style={{
                        '--contexify-activeItem-bgColor': '#009569',
                        '--contexify-menu-minWidth': '262px',
                    }}>
                        <Item id="copy" className="custom-menu-item" onClick={handleContext}>
                            <ContextItem icon={<CopyIconRight />} text="Copy" shortcut='Ctrl+C' />
                        </Item>
                        <Item id="paste" className="custom-menu-item" onClick={handleContext}>
                            <ContextItem icon={<PasteIconRight />} text="Paste" shortcut='Ctrl+V' />
                        </Item>
                        <Item id="delete" onClick={handleContext} className="custom-menu-item">
                            <ContextItem icon={<DeleteIconRight />} text="Delete" shortcut='DELETE' />
                        </Item>
                        {/* <Item id="developer" onClick={handleContext} className="custom-menu-item">
                            <ContextItem icon={<DeleteIconRight />} text="Developer" />
                        </Item> */}
                        {selectedElement?.type === IMG && (
                            <Divider />

                        )}
                        {selectedElement?.type === IMG && (
                            <Item id="replace" onClick={handleContext} className="custom-menu-item">
                                <ContextItem icon={<ReplaceImageIcon />} text="Replace Image" />
                            </Item>

                        )}
                        <Divider />
                        <SubmenuItem label={
                            <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                <AlignIconRight />
                                <Typography variant="body2">Align</Typography>
                            </span>
                        } className="custom-menu-item">
                            <Item id="left" className="custom-menu-item" onClick={handleContext}>
                                <ContextItem icon={<AlignLeft />} text="Left" />
                            </Item>
                            <Item id="center" className="custom-menu-item" onClick={handleContext}>
                                <ContextItem icon={<AlignVertical />} text="Center" />
                            </Item>
                            <Item id="right" className="custom-menu-item" onClick={handleContext}>
                                <ContextItem icon={<AlignRight />} text="Right" />
                            </Item>
                            <Divider />
                            <Item id="top" className="custom-menu-item" onClick={handleContext}>
                                <ContextItem icon={<AlignTop />} text="Top" />
                            </Item>
                            <Item id="middle" className="custom-menu-item" onClick={handleContext}>
                                <ContextItem icon={<AlignHorizontal />} text="Middle" />
                            </Item>
                            <Item id="bottom" className="custom-menu-item" onClick={handleContext}>
                                <ContextItem icon={<AlignBottom />} text="Bottom" />
                            </Item>
                        </SubmenuItem>
                        <Submenu label={
                            <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                <LayerIconRight />
                                <Typography variant="body2">Layers</Typography>
                            </span>
                        } className="custom-menu-item" icon={<LayerIconRight />}>
                            <Item id="bring_front" onClick={handleContext} className="custom-menu-item">
                                {/* <ContextItem icon={<KeyboardDoubleArrowUpIcon />} text="Bring to front" shortcut='Shift+Ctrl+]' /> */}
                                <ContextItem icon={<KeyboardDoubleArrowUpIcon />} text="Bring to front" />
                            </Item>
                            <Item id="bring_forward" onClick={handleContext} className="custom-menu-item">
                                {/* <ContextItem icon={<KeyboardArrowUpIcon />} text="Bring forward" shortcut='Ctrl+]' /> */}
                                <ContextItem icon={<KeyboardArrowUpIcon />} text="Bring forward" />
                            </Item>
                            <Item id="send_backward" onClick={handleContext} className="custom-menu-item">
                                {/* <ContextItem icon={<KeyboardArrowDownIcon />} text="Send Backward" shortcut='Ctrl+[' /> */}
                                <ContextItem icon={<KeyboardArrowDownIcon />} text="Send Backward" />
                            </Item>
                            <Item id="send_back" onClick={handleContext} className="custom-menu-item">
                                {/* <ContextItem icon={<KeyboardDoubleArrowDownIcon />} text="Send to back" shortcut='Shift+Ctrl+[' /> */}
                                <ContextItem icon={<KeyboardDoubleArrowDownIcon />} text="Send to back" />
                            </Item>
                        </Submenu>
                    </LolMenu>
                    {/* Hello Canvas */}
                    {selectedSlide?.elements?.length > 0 && selectedSlide.elements.filter((el) => el).map((el, index) => (
                        <CanvasElements el={el} index={el.id} key={el.id} style={style} setStyle={setStyle} lcanvasRef={lcanvasRef} />
                    ))}
                </Box>
            </CanvasBox>
        </Container>
    );
};

export default CanvasFrame;
